import { gql } from 'apollo-angular';

export const GET_CARGO_REVIEW = gql`
  query GetCargoReview($requestUuid: UUID) {
    getPrivateTransitCargoRequest(requestUuid: $requestUuid) {
      status
      message
      data {
        uuid companyName receiptNumber requestStatus requestVersion requestReason createdAt
        baselineVesselName baselineImoNumber baselineContractReferenceNo
        baselineTenderLotReferenceNo baselineCargoLineUpReferenceNo baselineAllocationReferenceNo
        baselineFirstDeliveryDate baselineLastDeliveryDate baselineTenderedQuantityMt baselineTenderedPremium
        vesselUsableCapacityMt currentBpsCargoMt otherApprovedCargoMt totalRequestedMt
        preliminarySpareCapacityMt capacitySufficient stowagePlanReference
        segregationCompatibilityNotes proposedLoadDischargeSequence
        declarationUndeclaredAtBid declarationNoPrejudiceToBps declarationSupplierResponsibility
        declarationAuthorisedSignatory declarantName declarantTitle declarationAcceptedAt
        actualSubmittedAt requestDeadlineAt lateRequest lateDispositionReason
        approvedPrivateQuantityMt dilutedPremium fullCargoQuantityMt effectiveAllocationVersion
        decisionBlockReason decisionOutcome staleReason workflowInstanceId workflowStatus
        attachments {
          uuid minioObjectName otherAttachmentName
          attachmentType { name fileType }
        }
        reviewParcels: parcels {
          uuid parcelReference productGrade quantityMt shipperName
          consignee { companyName countryName }
          destinationTerminal { terminalName }
          transitCountryCode transitCountryName transitClassification
          product { productName }
        }
        decisions {
          uuid decisionVersion decisionStatus recommendation recommendationReason
          capacityFindings productCompatibilityFindings routeCustomsFindings noPrejudiceFindings
          tenderedPremium premiumCurrency premiumSourceReference approvedPrivateQuantityMt
          verifiedSpareCapacityMt dilutedPremium fullCargoQuantityMt
          conditions conditionsExpireAt supplierAcknowledgementRequired supplierAccepted supplierResponseReason
          statusReason recommendedBy recommendedByUsername recommendedAt approvedByUsername effectiveAllocationVersion
          parcelDecisions {
            uuid requestedQuantityMt approvedQuantityMt reason
            parcel { uuid parcelReference }
          }
        }
      }
    }
  }
`;

export const RECOMMEND_CARGO_DECISION = gql`
  mutation RecommendCargoDecision($input: PrivateTransitCargoRecommendationReqInput) {
    recommendPrivateTransitCargoDecision(input: $input) {
      status
      message
      data { uuid }
    }
  }
`;
